import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  background: {
    backgroundColor: Theme.withOpacity(Theme.blackPearlBlue, 0.5),
    height: Theme.px(156),
    width: Theme.px(170),
  },
  dataLayout: {
    alignItems: 'center',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
  },
  iconWrapper: {
    alignItems: 'center',
    height: Theme.px(65),
    justifyContent: 'center',
    paddingBottom: Theme.px(2),
    paddingTop: Theme.px(2),
    width: Theme.px(65),
  },
  precipText: {
    color: Theme.secondaryText,
  },
  spacer: {
    width: Theme.px(1),
  },
  tempPrecipWrapper: {
    alignItems: 'baseline',
    flexDirection: 'row',
  },
});
